/* eslint-disable no-shadow, @typescript-eslint/naming-convention */
import { GoalCategory } from '../../../Generated/graphql-types'

export enum ActionElementType {
  BUTTON = 'Button',
  CHECKBOX = 'Checkbox',
  RADIO = 'Radio',
  SELECT = 'Select',
  TEXT_FIELD = 'TextField',
}

export const priorityGoals: Partial<
  Record<
    GoalCategory,
    { category: GoalCategory; label: string; templateLibraryId: string }[]
  >
> = {
  [GoalCategory.BoardManagement]: [
    {
      category: GoalCategory.BoardManagement,
      label: 'Recruiting new board members',
      templateLibraryId: '34',
    },
    {
      category: GoalCategory.BoardManagement,
      label: 'Activating and engaging my current board',
      templateLibraryId: '35',
    },
    {
      category: GoalCategory.BoardManagement,
      label: 'Retaining my board members',
      templateLibraryId: '36',
    },
  ],
  [GoalCategory.Compliance]: [
    {
      category: GoalCategory.Compliance,
      label: 'Establishing 501c3 status',
      templateLibraryId: '41',
    },
    {
      category: GoalCategory.Compliance,
      label: 'Maintaining 501c3 status',
      templateLibraryId: '42',
    },
  ],
  [GoalCategory.Fundraising]: [
    {
      category: GoalCategory.Fundraising,
      label: 'Creating an overall fundraising plan',
      templateLibraryId: '32',
    },
    {
      category: GoalCategory.Fundraising,
      label: 'Creating a fundraising campaign appeal',
      templateLibraryId: '33',
    },
  ],
  [GoalCategory.Grants]: [
    {
      category: GoalCategory.Grants,
      label: 'Writing effective grant applications',
      templateLibraryId: '39',
    },
    {
      category: GoalCategory.Grants,
      label: 'Finding grants for my organization',
      templateLibraryId: '40',
    },
  ],
  [GoalCategory.MarketingCommunications]: [
    {
      category: GoalCategory.MarketingCommunications,
      label: 'Sharing your stories & campaigns on social media.',
      templateLibraryId: '47',
    },
    {
      category: GoalCategory.MarketingCommunications,
      label: 'Creating branding (what makes our organization unique)',
      templateLibraryId: '48',
    },
  ],
  [GoalCategory.PeopleOperations]: [
    {
      category: GoalCategory.PeopleOperations,
      label: 'Creating hiring and onboarding plans for new employees',
      templateLibraryId: '37',
    },
    {
      category: GoalCategory.PeopleOperations,
      label: 'Increasing employee engagement and happiness',
      templateLibraryId: '38',
    },
  ],
  [GoalCategory.Storytelling]: [
    {
      category: GoalCategory.Storytelling,
      label: 'Creating a compelling story that showcases your impact',
      templateLibraryId: '45',
    },
    {
      category: GoalCategory.Storytelling,
      label: 'Using marketing and social media',
      templateLibraryId: '46',
    },
  ],
  [GoalCategory.StrategicPlanning]: [
    {
      category: GoalCategory.StrategicPlanning,
      label: 'Drafting our strategic plan',
      templateLibraryId: '43',
    },
    {
      category: GoalCategory.StrategicPlanning,
      label: 'Implementing a strategic planning',
      templateLibraryId: '44',
    },
  ],
}

export const confidenceLevels: { label: string; value: number }[] = [
  { label: '1 - Very low: Little to no knowledge', value: 1 },
  { label: '2 - Low:  Basic and limited understanding', value: 2 },
  { label: '3 - Moderate: Fair understanding with some gaps', value: 3 },
  {
    label: '4 - High: Strong understanding and able to discuss the topic',
    value: 4,
  },
  {
    label:
      '5 - Very high: Expert-level understanding and comprehensive knowledge',
    value: 5,
  },
]

export const changeLevels: { label: string; value: string }[] = [
  { label: '1 - Very negative change', value: '1' },
  { label: '2 - Some negative change', value: '2' },
  { label: '3 - No change', value: '3' },
  { label: '4 - Some positive change', value: '4' },
  { label: '5 - Very positive change', value: '5' },
  { label: '0 - Unsure', value: '0' },
]
